import { ApiRequester } from "../ApiRequester"

interface RequestDataShape {
	id: string
}

export async function discussionReplyDeleteApi(payload: RequestDataShape, token: string) {
	const endpoint = "/discussion/reply/delete/v1"
	const requester = new ApiRequester<RequestDataShape, void>(endpoint)
	await requester.sendRequest(payload, token)
}
